<template>
  <v-app style="background-image: linear-gradient(#0071BB, #004071)">
    <v-card elevation="1" class="custom-card">
      <BaseHeader>
        <v-flex offset-xs6 offset-sm9>
          <v-select
            v-model="language"
            :items="languages"
            class="pa-0 ma-0"
            hide-details
          ></v-select>
        </v-flex>
      </BaseHeader>

      <v-layout row wrap pb-3 class="main-wrapper">
        <PaymentDetails></PaymentDetails>
        <v-flex
          xs12
          sm6
          pa-3
          pl-4
          :class="{ 'pr-5': $vuetify.breakpoint.smAndUp }"
        >
          <v-flex class="pb-3 custom_text_18" @click="split_paid = !split_paid">
            {{ text.header }}
          </v-flex>

          <v-flex class="pb-3 body-1">
            {{ text.subheader }}
          </v-flex>

          <v-flex class="pb-1 caption font-weight-bold">
            {{ text.header }}
          </v-flex>

          <v-flex xs10 class="pb-2">
            <v-text-field
              outline
              label="จำนวนเงิน"
              placeholder="จำนวนเงิน"
              type="number"
              v-model="amount"
              single-line
              :hint="text.hint"
              persistent-hint
              @blur="checkAmount"
            ></v-text-field>
          </v-flex>

          <v-layout row>
            <change-payment-method class="xs6" />

            <v-flex xs6 class="pb-3 body-1 text-xs-right">
              <a
                v-if="amount != total_price"
                href="#"
                @click="fullPaid"
                disabled
              >
                {{ text.fullpaid }}
              </a>
            </v-flex>
          </v-layout>
          <v-flex>
            <v-btn
              :to="route"
              block
              round
              large
              color="primary"
              :disabled="minPay.disabled"
            >
              {{ text.nextButton }}
            </v-btn>
          </v-flex>
        </v-flex>
      </v-layout>

      <BaseFooter :selected_payment_method="false"></BaseFooter>
    </v-card>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      minPay: {
        amount: 0,
        disabled: false
      },
      split_paid: false,
      languages: ['ไทย', 'อังกฤษ', 'จีน'],
      language: 'ไทย',
      method: this.$route.params.method
    }
  },
  computed: {
    amount: {
      get() {
        return this.$store.state.amount
      },
      set(newValue) {
        newValue = parseFloat(newValue)
        if (!newValue) newValue = 0
        if (newValue > this.minPay.amount) {
          this.minPay.disabled = false
        } else {
          this.minPay.disabled = true
        }
        this.$store.dispatch('changeAmount', newValue)
      }
    },
    total_price() {
      return this.$store.state.outstanding
    },
    outstanding() {
      return this.twoDecimal(this.total_price - this.amount)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    route() {
      let route
      if (this.method == 'CreditCard' || this.method == 'CreditUnion') {
        route = '/credit/'
      } else {
        route = '/qr/'
      }
      return route + this.method + '/?linkcode=' + this.$route.query.linkcode
    },
    text() {
      let obj = {}
      if (this.$store.state.language == 'EN') {
        obj = {
          header: 'Specific the amount to pay',
          subheader:
            'Pay more than 1 card, please make 1 transaction at a time, specifying the amount to pay for each card.',
          fullpaid: 'Pay in full',
          nextButton: 'Next',
          hint: `Outstanding ${this.outstanding} THB`
        }
      } else {
        obj = {
          header: 'ระบุจำนวนเงินที่ต้องการชำระ',
          subheader:
            'หากต้องการชำระมากกว่า 1 บัตร กรุณาทำรายการครั้งละ 1 บัตร โดยระบุจำนวนเงินที่ต้องการชำระในแต่ละครั้ง',
          fullpaid: 'ชำระเต็มจำนวน',
          nextButton: 'ดำเนินการต่อ',
          hint: `จะเหลือยอดค้างชำระ ${this.outstanding} บาท`
        }
      }
      return obj
    }
  },
  methods: {
    fullPaid() {
      this.amount = this.total_price
    },
    checkAmount() {
      if (
        parseFloat(this.amount) > this.total_price ||
        parseFloat(this.amount) < 0
      ) {
        this.amount = this.total_price
      }
    },
    twoDecimal(val) {
      return parseFloat(val).toFixed(2)
    }
  }
}
</script>
